import mapboxgl from 'mapbox-gl'
import { isRTL } from '../platform'

let hasLoadedRTLPlugin = false

export function mapboxInitialize() {
	mapboxgl.accessToken = ENV.MAP_API_ACCESS_TOKEN
}

export function mapboxSetSupportedLanguages(languageCodes: string[]) {
	const isAnyRTL = languageCodes.some(code => isRTL(code))
	if (isAnyRTL) {
		if (!hasLoadedRTLPlugin) {
			// from https://docs.mapbox.com/mapbox-gl-js/example/mapbox-gl-rtl-text/
			mapboxgl.setRTLTextPlugin(
				'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.3.0/mapbox-gl-rtl-text.js',
				null,
				true,
			)
			hasLoadedRTLPlugin = true
		}
	}
}
